import React, { useState, useEffect } from 'react';
import values from 'lodash/values';
import { useDebounce } from 'use-debounce';
import Config from '../../config';
import SearchInput from '../ConversationsList/SearchInput';
import SmartListItem from './SmartListItem';
import Filter from './Filter';
import icons from '../../icons';
import axios from 'axios';
import orderBy from 'lodash/orderBy';
import { SMARTLISTTYPES, SMARTLISTFILTERS, listSchema, initialFilter } from './reducer';
import { normalize } from 'normalizr';
import * as localforage from 'localforage';
import LoadingAnimation from '../../components/LoadingAnimation';

const SmartListComponent = ({ translate, state, dispatchState, filters, dispatchFilters }) => {
    const [perPage, setPerPage] = useState('100');
    const [pages, setPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState('');
    const [debouncedSearchValue] = useDebounce(searchValue, 500);
    const [filterOpen, setFilterOpen] = useState(false);
    const [activeFilters, setActiveFilters] = useState(filters !== initialFilter);
    const [filterOptions, setFilterOptions] = useState([]);

    const loadData = async (take, limit) => {
        const token = await localforage.getItem('token');
        setLoading(true);

        axios.get(
            `${Config.smartlist_url}`,
            {
                params: {
                    filter: 1,
                    ...filters,
                    iDisplayStart: (take * limit) - limit,
                    iDisplayLength: limit,
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(resp => {
                setData(resp.data);
                setLoading(false);
            })
            .catch(err => {
                console.error('err', err);
                setLoading(false);
            });
    };

    const loadFilterOptions = async () => {
        const token = await localforage.getItem('token');

        axios.get(
            `${Config.smartlist_filter_url}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then((resp: any) => {
                setFilterOptions(resp.data.filters);
            })
            .catch(err => console.error('err', err));
    };

    const setData = (data) => {
        if (data && data.data) {
            const normalizedData = normalize(data.data, [listSchema]);
            dispatchState({
                type: SMARTLISTTYPES.ADD,
                data: normalizedData.entities.smartlist
            });
        }

        if (data && data.totals) {
            const limit = Number(perPage);
            const totalPages = Math.ceil(Number(data.totals) / limit);
            setPages(totalPages);
        }
    };

    useEffect(() => {
        loadFilterOptions();
    }, []);

    useEffect(() => {
        loadData(currentPage, Number(perPage));
    }, [filters]);

    useEffect(() => {
        if (searchValue.trim() !== '') {
            loadData(1, null);
        } else {
            loadData(currentPage, Number(perPage));
        }
    }, [debouncedSearchValue]);

    const filteredData = () => {
        const sortedData = orderBy(values(state), ['timestamp'], ['desc']);

        if (searchValue) {
            return sortedData.filter((item) => (
                item.primary_contact_name.toLowerCase().includes(searchValue.toLowerCase()) ||
                item.outlet_name.toLowerCase().includes(searchValue.toLocaleLowerCase()) ||
                item.list_name.toLowerCase().includes(searchValue.toLocaleLowerCase())
            ));
        }

        return sortedData;
    };

    const handlePerPageChange = e => {
        setPerPage(e.currentTarget.value);
        loadData(1, e.currentTarget.value);
    };

    const handlePrevPage = () => {
        setCurrentPage(currentPage - 1);
        loadData(currentPage - 1, Number(perPage));
    };

    const handleNextPage = () => {
        setCurrentPage(currentPage + 1);
        loadData(currentPage + 1, Number(perPage));
    };

    return (
        <div className="sl__wrapper">
            {filterOpen &&
                <Filter
                    filters={filterOptions}
                    selected={filters}
                    onApply={payload => {
                        setFilterOpen(false);
                        dispatchFilters({
                            type: SMARTLISTFILTERS.UPDATE,
                            payload
                        });
                        setActiveFilters((payload !== initialFilter));
                    }}
                    onCancel={() => setFilterOpen(false)}
                    onClose={() => setFilterOpen(false)}
                    onReset={() => {
                        dispatchFilters({
                            type: SMARTLISTFILTERS.DEFAULT
                        });
                        setActiveFilters(false);
                    }}
                />
            }
            <div className="sl__header">
                <SearchInput
                    label="conversationsList"
                    setSearchValue={text => setSearchValue(text)}
                    placeholder={'Search'}
                    searchValue={searchValue}
                />
                <div className={activeFilters ? 'sl__filterbtn is-active' : 'sl__filterbtn'} onClick={() => setFilterOpen(true)}>
                    Filters
                </div>
            </div>
            <div className="sl__content">
                {filteredData().length === 0 && !loading && filters === initialFilter &&
                    <div className="conversationsList__scroll">
                        <div className="conversationsList__placeholder">
                            <p>You have no assigned accounts.<br />Please contact your Dealer Administrator for assistance.</p>
                        </div>
                    </div>
                }
                {filteredData().length === 0 && !loading && filters !== initialFilter &&
                    <div className="conversationsList__scroll">
                        <div className="conversationsList__placeholder">
                            <p>No results.<br />Adjust your filters and try again.</p>
                        </div>
                    </div>
                }
                {filteredData().length === 0 && loading &&
                    <LoadingAnimation />
                }
                {filteredData().length > 0 && filteredData().map((item, key) => (
                    <SmartListItem
                        key={key}
                        item={item}
                    />
                ))}
            </div>
            <div className="sl__footer">
                <div className="">
                    <select className="sl__pagination__select" value={perPage} onChange={handlePerPageChange}>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="250">250</option>
                    </select>
                </div>
                <div className="sl__pagination">
                    <button type="button" disabled={currentPage === 1} onClick={handlePrevPage}>{icons.paginationLeft}</button>
                    <span>{currentPage}</span>
                    <button type="button" disabled={currentPage === pages} onClick={handleNextPage}>{icons.paginationRight}</button>
                </div>
            </div>
        </div>
    );
};

export default SmartListComponent;



// WEBPACK FOOTER //
// ./src/sections/SmartList/SmartListComponent.tsx